import * as tslib_1 from "tslib";
import { AfterViewInit, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Setting } from '@app-state';
import { enumMapper, FeatureFlag, FolderType, LicenseErrorCode, ROBOT_LICENSE_TYPE_FILTER, ROBOT_STATE_FILTER, RobotHostingType, RobotLicenseType, RobotProvisionType, RobotState, RobotType, RobotTypeAttended, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { FloatingRobotModalComponent } from '@pages/robots/modal/robot-floating.modal';
import { StandardRobotModalComponent } from '@pages/robots/modal/robot-standard.modal';
import { CheckPermissionsModalComponent } from '@pages/users/modals';
import { EnvironmentService, MachineService, RobotService, SessionsService, SignalRService, UserService, } from '@services';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import * as moment from 'moment';
import { BehaviorSubject, merge, } from 'rxjs';
import { filter, finalize, map, switchMap, takeUntil, } from 'rxjs/operators';
var FolderDependentSessionService = /** @class */ (function (_super) {
    tslib_1.__extends(FolderDependentSessionService, _super);
    function FolderDependentSessionService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.folderType = FolderType.Classic;
        return _this;
    }
    FolderDependentSessionService.prototype.get = function (queryOptions) {
        var endpoint = this.folderType === FolderType.Classic
            ? '/odata/Sessions'
            : '/odata/Sessions/UiPath.Server.Configuration.OData.GetGlobalSessions';
        return _super.prototype.get.call(this, queryOptions, endpoint);
    };
    return FolderDependentSessionService;
}(SessionsService));
export { FolderDependentSessionService };
var ɵ0 = urlStateHandler;
var RobotsPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RobotsPageComponent, _super);
    function RobotsPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLicenseInvalid$ = _this._appState.user.license.value$
            .pipe(map(function (license) { return license.isExpired; }));
        _this.RobotHostingType = RobotHostingType;
        _this.RobotType = RobotType;
        _this.LicenseErrorCode = LicenseErrorCode;
        _this.RobotProvisionType = RobotProvisionType;
        _this.userIdLoading$ = new BehaviorSubject(null);
        _this.isMonitoringEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.Monitoring);
        _this.isModernFoldersEnabled = !!_this._appState.settings.get(Setting.isModernFolderSystemEnabled);
        _this.isRobotsViewGranted$ = _this._appState.user.permissions.isGranted('Robots.View');
        _this.isRobotsCreateGranted$ = _this._appState.user.permissions.isGranted('Robots.Create');
        _this.isEnvironmentsViewGranted$ = _this._appState.user.permissions.isGranted('Environments.View');
        _this.isMachinesViewGranted$ = _this._appState.user.permissions.isGranted('Machines.View');
        _this.refetchMap = {
            machineName: false,
            userName: false,
        };
        _this.typeList = enumMapper(RobotType, {
            resourceKey: 'RobotType',
        });
        _this.hostingTypeList = enumMapper(RobotHostingType, {
            resourceKey: 'RobotHostingType',
        });
        _this.licenseList = enumMapper(RobotLicenseType, {
            resourceKey: 'RobotLicenseType',
            filterValueMap: ROBOT_LICENSE_TYPE_FILTER,
        });
        _this.stateList = enumMapper(RobotState, {
            resourceKey: 'RobotState',
            filterValueMap: ROBOT_STATE_FILTER,
        });
        _this._environmentService = _this._injector.get(EnvironmentService);
        _this._robotService = _this._injector.get(RobotService);
        _this._signalR = _this._injector.get(SignalRService);
        _this._user = _this._injector.get(UserService);
        _this._route = _this._injector.get(ActivatedRoute);
        _this.machineNameSuggest = function (term, size, skip) {
            _this.refetchMap.machineName = false;
            return _this._injector.get(MachineService).machineNameSuggest(term, size, skip);
        };
        _this.userNameSuggest = function (term, size, skip) {
            _this.refetchMap.userName = false;
            var service = _this.isGlobalView
                ? _this._service
                : _this._robotService;
            return service.userNameSuggest(term, size, skip);
        };
        _this.environmentNameSuggest = function (term, size, skip) {
            return _this._environmentService.environmentNameSuggest(term, size, skip);
        };
        _this.isFrontOffice = function (type) { return RobotTypeAttended[type] != null; };
        _this.isConvertibleToFloating = function (robot) { return _this.isFrontOffice(robot.type) && robot.hostingType === RobotHostingType.Standard; };
        _this._updateSessionState = function (message) {
            if (!message.isNew) {
                _this._grid.dataManager.patchRow(message.id, message);
                return;
            }
            // reload page for new sessions
            if (_this._grid.footer.state.pageIndex === 0 &&
                !_this._grid.header.searchValue &&
                !_this._grid.filterManager.filter$.value.length) {
                _this._refresh$.next();
            }
        };
        _this._updateRobotLicensesState = function (_a) {
            var robotId = _a.robotId, hasLicense = _a.hasLicense, timestamp = _a.timestamp;
            var session = _this._findSessionByRobotId(robotId);
            if (!session || !session.robot) {
                return;
            }
            _this._grid.dataManager.patchRow(session.id, {
                robot: {
                    license: hasLicense ? { timestamp: timestamp } : undefined,
                },
            });
        };
        return _this;
    }
    Object.defineProperty(RobotsPageComponent.prototype, "hasBusyRobotsSelected", {
        get: function () {
            return this._grid.selectionManager.selected.some(function (session) { return session.state === RobotState[RobotState.Busy]; });
        },
        enumerable: true,
        configurable: true
    });
    RobotsPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isGlobalView = !!this._route.snapshot.data && this._route.snapshot.data.isModernContext;
        this._service.folderType = this.isGlobalView
            ? FolderType.Modern
            : FolderType.Classic;
        this._signalR.sessions$
            .pipe(filter(function () { return !!_this._grid.dataManager.length; }), takeUntil(this._destroyed$))
            .subscribe(this._updateSessionState);
        this.data$
            .subscribe(function (sessions) { return _this._signalR.watchRobots(sessions.map(function (session) { return session.robot.id; })); });
        this._signalR.robotLicenses$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(this._updateRobotLicensesState);
        this._signalR.watchNewRobots();
        this._expand$.next(['Robot($expand=License)']);
    };
    RobotsPageComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._signalR.watchRobots(false);
        this._signalR.watchNewRobots(false);
    };
    RobotsPageComponent.prototype.onRemoveItems = function (items) {
        var _this = this;
        var toDelete = items || this._grid.selectionManager.selected;
        this._modal.onConfirm(null, function () {
            _this.loading$.next(true);
            var robotIds = toDelete.map(function (session) { return session.robot.id; });
            var robotId = robotIds[0];
            var deleteAction = toDelete.length === 1 ?
                _this._robotService.delete(robotId) :
                _this._robotService.deleteBulk(robotIds);
            deleteAction
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () { return _this._refresh$.next(); });
        }, function () { }, this._translate.instant('grid_action_delete_message'));
    };
    RobotsPageComponent.prototype.openModal = function (hostingType, session, duplicate) {
        var _this = this;
        if (duplicate === void 0) { duplicate = false; }
        if (this._modalSubscription) {
            this._modalSubscription.unsubscribe();
        }
        var modalComponent = hostingType === RobotHostingType.Standard ? StandardRobotModalComponent : FloatingRobotModalComponent;
        if (session &&
            session.robot) {
            this._modalSubscription = this._robotService
                .getInstance(session.robot.id)
                .pipe(switchMap(function (robot) {
                return _this._modal
                    .openModal(modalComponent, robot, {
                    isDuplicate: duplicate,
                    data: {
                        model: session,
                    },
                    autoFocus: false,
                })
                    .afterClosedResult();
            }), filter(Boolean))
                .subscribe(function (modalResult) {
                if (!duplicate) {
                    var robot = modalResult.data;
                    delete robot.license;
                    _this._grid.dataManager.patchRow(_this._findSessionByRobotId(robot.id).id, { robot: robot });
                }
                else {
                    _this._refresh$.next();
                }
                _this._activateRefetch();
            });
        }
        else {
            var modalRef = this._modal.openModal(modalComponent, void 0, {
                autoFocus: false,
            });
            this._modalSubscription = merge(modalRef.customEvent, modalRef.afterClosedResult()
                .pipe(filterNullOrUndefined())).subscribe(function () {
                _this._refresh$.next();
                _this._activateRefetch();
            });
        }
    };
    RobotsPageComponent.prototype.convertToFloating = function (robot) {
        var _this = this;
        this._modal.onConfirm(null, function () {
            _this._robotService.convertToFloating(robot.id)
                .subscribe(function () { return _this._grid.refresh.next(); });
        }, function () { }, this._translate.instant('robot_modal_form_convert_to_floating_info'));
    };
    RobotsPageComponent.prototype.formatRobotAcquiredOnDate = function (date) {
        return moment(date)
            .tz(this._appState.settings.get(Setting.timezone))
            .format('L LTS');
    };
    RobotsPageComponent.prototype.checkPermissions = function (userId) {
        var _this = this;
        this.userIdLoading$.next(userId);
        this._user.getInstance(userId).pipe(finalize(function () { return _this.userIdLoading$.next(null); }), switchMap(function (user) {
            return _this._modal
                .openModal(CheckPermissionsModalComponent, user)
                .afterClosedResult();
        })).subscribe();
    };
    RobotsPageComponent.prototype._ouDependentFilters = function () {
        return ['robot.userName', 'robot.environments.id'];
    };
    RobotsPageComponent.prototype._activateRefetch = function () {
        this.refetchMap.machineName = true;
        this.refetchMap.userName = true;
    };
    RobotsPageComponent.prototype._findSessionByRobotId = function (robotId) {
        return this._grid.dataManager.data$.value.find(function (entry) { return entry.robot.id === robotId; });
    };
    return RobotsPageComponent;
}(ODataGridComponent));
export { RobotsPageComponent };
export { ɵ0 };
